import * as React from 'react';

export type ImageProps =
    React.HTMLAttributes<HTMLElement> & {
        pictureRef?: PictureRef;
        imageSrc?: string;
        sizes?: string;
        srcSet?: string;
        minWidth?: number;
        maxWidth?: number;
        steps?: number;
        alt?: string;
        // includeRatio?: boolean;
        onLoad?: () => void;
        onError?: () => void;
    }

export class Image extends React.Component<ImageProps> {
    public render() {
        const { alt, className } = this.props;

        const maxWidth = this.props.maxWidth || 4000;
        const minWidth = this.props.minWidth || 200;
        let steps = (this.props.steps || 8);
        const stepSize = (maxWidth - minWidth) / steps;
        const sizes = this.props.sizes || '100vw';
        const width = this.props.pictureRef && this.props.pictureRef.Width || 0;
        const imageSrc = this.props.pictureRef && this.props.pictureRef.Src || this.props.imageSrc || '';

        const srcSet: string[] = [];
        steps++;

        while (steps--) {
            const w = stepSize * steps + minWidth;
            if (width && w > width) { continue; }
            const src = `${imageSrc}?width=${w} ${w}w`;
            srcSet.push(src);
        }

        const atts: React.ImgHTMLAttributes<HTMLImageElement> = {
            alt,
            className,
            sizes,
            src: `${imageSrc}`,
            srcSet: srcSet.join(', ') || ''
        };

        if (this.props.onLoad) {
            atts.onLoad = this.props.onLoad;
        }

        if (this.props.onError) {
            atts.onError = this.props.onError;
        }

        return (
            <img
                {...atts}
            />);

    }
}

export default Image;


// WEBPACK FOOTER //
// ./src/components/Image.tsx